console.log(`${window.location.protocol}//${window.location.host}`);

// Build url to work with vercel's dynamic urls

const hostUrl = `${window.location.protocol}//${window.location.host}`;

export const AUTH_CONFIG = {
  domain: import.meta.env.VITE_APP_DOMAIN,
  clientId: import.meta.env.VITE_APP_CLIENT_ID,
  callbackUrl: hostUrl,
  hostUrl,
  apiUrl: import.meta.env.VITE_APP_API_URL,
  ENV: import.meta.env.VITE_APP_ENV,
  GOOGLE_APP_ID: import.meta.env.VITE_APP_GOOGLE_APP_ID,
  GOOGLE_API_KEY: import.meta.env.VITE_APP_GOOGLE_API_KEY,
  GOOGLE_CLIENT_ID: import.meta.env.VITE_APP_GOOGLE_CLIENT_ID,
  cleanToolUrl: import.meta.env.VITE_APP_CLEAN_TOOL_URL,
};
